import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {select, Store} from '@ngrx/store';

import {takeUntil, take} from 'rxjs/operators';
import {IDac6ReporterState} from '../../store/reducers/dac6-reporter.reducer';
import {
  PreArrangeMentsDeleteCommand, CreatePreArrangementCommand, UpdatePreArrangementCommand,
  SyncProjectEntityToCompanyCommand,
  CreateArrangementCommand, MovePreArrangementToArrangementCommand, CreatePreArrangementFromExistingCaseCommand, ArchiveCaseCommand, SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand, UnarchiveCaseCommand, ArchiveSingleCaseCommand
} from '../../commands/dac6-reporter.command';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {getCurrentBasket, getViewType, ParticleState} from '@shared/store/reducers/particle.reduer';
import {SmartGridService} from '@core/services/smart-grid.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {CommandService} from '@core/services/command.service';
import {ParticleService} from '@core/services/particle.service';
import {DialogService} from '@shared/services/dialog-service';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {Dac6CellDecoratorComponent} from '../dac6-cell-decorator/dac6-cell-decorator.component';
import {Configuration} from '@shared/models/configuration';
import {ParticleConfig} from '../../../particle-config';
import {UpdateFieldDefinitionCommand} from '@shared/commands/update-field-definition.command';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {DialogModel} from '@shared/models/dialog.model';
import {SetViewTypeAction} from '@shared/store/actions/particle.actions';
import {getVirtualGridSelectedIndex} from '@shared/store/selectors/virtual-grid.selector';
import {ICollaborationConsumerComponent} from '@shared/components/platform-sidebar/store/view-synchronizer.interfaces';
import {CollaborationState} from '../../../task-manager/collaboration/store/collaboration.reducer';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {
  SetActivityFeedAction,
  ShowHiddenRightSideComponentAction
} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {ContentScope, PlatformCommand} from '@shared/commands/command-base';
import { BasketProvider } from '@shared/models/basket-provider';
import {
  ConversationComponentName,
  FieldConversationComponentName
} from '../../../task-manager/collaboration/store/collaboration.constants';
import {
  CreateChatConversationAction,
  CreateConversationAction
} from '../../../task-manager/collaboration/store/collaboration.action';
import {
  CreateChatConversationCommand,
  CreateConversationWithRelativePathCommand
} from '../../../task-manager/collaboration/store/collaboration.command';
import {AddFieldDefinitionCommand} from '@shared/commands/add-field-definition.command';
import {AddCaseStatusCommand} from '@shared/commands/case-status.command';
import {RowClassArgs} from '@progress/kendo-angular-grid';
import {DownloadFileCommand} from '../../../file-manager/commands/create-directory.command';
import {DownloadFileAction} from '../../../file-manager/store/actions/file-manager.actions';
import {IFileStoreState} from '@shared/store/reducers/file-store.reducer';
import {BasketModel} from '@shared/models/common.models';
import {AddSurveyCommand} from '@shared/commands/shared.commands';
import {BasketId} from "../../Fields";
import {Dynamic_Grid_Data_Request_Parameters} from "@shared/store/actions/virtual-grid.actions";
import {ParticleCacheService} from "@core/services/particle-cache.service";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';


@Component({
    standalone: false,
    selector: 'lib-pre-arrangement-content',
  templateUrl: './pre-arrangement-content.component.html',
  styleUrls: ['./pre-arrangement-content.component.scss']
})
export class PreArrangementContentComponent implements OnInit, OnDestroy {
  sourceType: string;
  currentSelectedItems: string[];
  flag: boolean;
  deleteDisabled: boolean;
  numberOfTabs$: Observable<any>;
  unSubscribe$ = new Subject<void>();
  hasNoExtraTab = true;
  invalidateSubject: InvalidateSubject;
  breadcrumbs: BreadcrumbModel[];
  tabs: any[];
  selectedTab: any;
  actions: any[];
  viewType: string;
  endpoint = 'Dac6Api';
  private selectedFieldSectionIndex$: Observable<number>;
  private selectedTabIndex: any;
  filterId: string; // = 'PreArrangement';
  fieldHistorySourceType: string = 'Dac6-Field-History';
  showArchived: boolean;
  selectedBasket: BasketModel;
  showAnnouncement: boolean = false;
  announcementContent: string = '';

  constructor(private router: Router,
              private store: Store<IDac6ReporterState>,
              private particleService: ParticleService,
              private smartGridService: SmartGridService,
              private particleStore: Store<ParticleState>,
              private particleCacheService: ParticleCacheService,
              protected commandService: CommandService,
              private activatedRoute: ActivatedRoute,
              private collaborationStore: Store<CollaborationState>,
              private snackBarService: SnackBarService,
              private dialogService: DialogService,
              private queryState: Store<IQueryState>,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private fuseSplashScreenService: FuseSplashScreenService,
              private fileStoreCommonService: FileStoreCommonService,
              private fileStore: Store<IFileStoreState>) {
    this.showArchived = false;
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'Case',
        title: 'DAC6 & MDR Reporter',
        type: 'Case',
        relativeUrl: 'dac6-reporter/overview'
      },
      <BreadcrumbModel>{
        id: 'PreArrangement',
        title: 'Pre-Arrangements',
        type: 'PreArrangement',
        relativeUrl: 'dac6-reporter/pre-arrangement'
      }
    ];
    this.tabs = [];
    this.viewType = 'Expanded';
    this.actions = [
      {
        text: 'Create Case',
        doAction: this.createCase,
        self: this
      },
      {
        text: 'Import',
        doAction: this.import,
        self: this
      },
      {
        text: 'Export',
        doAction: this.exportPreArrangement,
        self: this
      },
      {
        text: 'Manage Fields',
        doAction: this.manageSection,
        self: this
      },
      {
        text: 'Start Survey',
        doAction: this.startDataSurvey,
        self: this
      }
    ];
    this.sourceType = 'PreArrangement';
    this.invalidateSubject = new InvalidateSubject();
    particleService.registerCellComponent('Dac6CellDecorator', Dac6CellDecoratorComponent);
  }

  ngOnInit() {
    this.currentSelectedItems = [];
    this.flag = false;
    this.deleteDisabled = true;
    this.particleStore.pipe(select(getViewType)).subscribe(viewType => {
      this.viewType = viewType;
    });
    this.selectedFieldSectionIndex$ = this.store.pipe(select(getVirtualGridSelectedIndex, this.sourceType));
    this.selectedFieldSectionIndex$.pipe(takeUntil(this.unSubscribe$)).subscribe(state => {
      if (state >= 0 && state < this.tabs.length) {
        this.selectedTab = this.tabs[state];
      }
      this.selectedTabIndex = state;
    });
    const config = Configuration.getSmartGridConfig(this.sourceType);
    config['Parameters']['SHOW_ARCHIVED'] = this.showArchived;
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType, config['Parameters']);
    this.particleStore.pipe(select(getCurrentBasket), takeUntil(this.unSubscribe$)).subscribe((item: BasketModel) => {
      if (item) {
        this.selectedBasket = item;
      }
    });
    this.announcementContent = '<p><i class="far fa-info-circle"></i> <strong>Note:</strong> For United Kingdom, only the category D Hallmarks are applicable. Please&nbsp;\n<a href="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/dac6/download/uk-dac6-faq.pdf" target="_blank">download the FAQs document</a>&nbsp;for details.</p>';

    // const activityInfo = {type: 'Tool', 'id': 'dac6-pre-arrangement', 'title': 'Pre-Arrangements', isDefault: true};
    // this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
  }

  viewTypeChanged($event) {
    this.particleStore.dispatch(new SetViewTypeAction($event));
  }

  compactViewType() {
    this.particleStore.dispatch(new SetViewTypeAction('Compact'));
  }
  private navigateToDetailViewerTab(fieldDefinition, item) {
    if (item.cells[fieldDefinition.key].value !== 'Yes') {
      return ;
    }
    const fieldSectionKey = fieldDefinition.metaData['ChildHallmarkFieldSectionKey'];
    let selectedFieldSectionTabIndex = 0;
    for (let i = 0 ; i < this.tabs.length ; i++) {
      if (this.tabs[i].headerKey && this.tabs[i].headerKey === fieldSectionKey){
        selectedFieldSectionTabIndex = i;
        break;
      }
    }
    let routingPath = `dac6-reporter/pre-arrangement/detail/${item.id}?selectedTab=${selectedFieldSectionTabIndex}`;
    this.router.navigateByUrl(routingPath);
  }
  onFieldSectionChanged($event) {
    if ($event) {
      if (this.tabs.length) {
        this.tabs.splice(0, this.tabs.length);
      }
      let index = 0;
      if ($event.length > 0) {
        $event.forEach(f => {
          this.tabs.push({id: f.id, header: f.header, index: index++, headerKey: f.headerKey});
        });
        if (!this.selectedTab) {
          if (this.selectedTabIndex >= 0) {
            this.selectedTab = this.tabs[this.selectedTabIndex];
          } else {
            this.selectedTab = this.tabs[0];
          }
          // this.invalidateSubject.invalidate(`Selected Index: ${this.selectedTab.index}`);
        }
      }
    }
  }

  onSelectedTabChanged($event) {
    this.selectedTab = $event;
    this.invalidateSubject.invalidate(`Selected Index: ${this.selectedTab.index}`);
  }

  onCellEditorClosed(event) {
    console.log(event);
    this.router.navigate(['']);
  }

  onSelectionChanged(event) {
    if (this.flag) {
      this.currentSelectedItems = [];
    }
    this.flag = false;
    event.deselectedRows.forEach(item => {
      const index = this.currentSelectedItems.indexOf(item.dataItem.id);
      if (index > -1) {
        this.currentSelectedItems.splice(index, 1);
      }
    });
    event.selectedRows.forEach(item => {
      this.currentSelectedItems.push(item.dataItem.id);
    });
    if (this.currentSelectedItems.length > 0) {
      this.deleteDisabled = false;
    } else {
      this.deleteDisabled = true;
    }

  }

  addSection() {
    this.router.navigate(['add-section/' + 'PreArrangement'], {relativeTo: this.activatedRoute});
  }

  manageSection() {
    const command = new PlatformCommand('CreateManageFieldMagicLinkCommand', 'Dac6Api');
    command.fieldValues['SourceType'] = Configuration.getBasketMappedSourceType('PreArrangement');
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
      console.log('commandState', response);
      if (response.fieldValues['RedirectUrl']) {
        this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
      }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Failed to prearrangement managesection ', error);
      });
  }
  exportTransaction() {

  }

  createCase() {
    const dialogModel: DialogModel = DialogModel.create(
      'Create Case',
      'CreateCaseDialogComponent',
      {'caseType': 'PreArrangement', disableTypeChange: true},
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        switch (res.data.input.caseType) {
          case 'PreArrangement':
            if (res.data.input.specifyField) {
              res.data.input.archiveExisting = false;
              this.openSelectFieldDialog(res.data.input.selectedCase, 'prearrangementmodel', 'PreArrangement', res, res.data.input.selectedCase);
            } else {
              if (res.data.input.selectedCase) {
                this.addPreArrangementFromExistingCaseId(res.data.input.title, res.data.input.selectedCase, false, false);
              } else {
                this.addPreArrangement(res.data.input.title);
              }
            }
            break;
          case 'Arrangement':
            this.addArrangement(res.data.input.title);
            break;
        }
      }
    });
  }

  addArrangement(title: string) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CreateArrangementCommand(title)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`dac6-reporter/arrangement/${state.Payload.Id}`);
    });
  }

  addPreArrangement(title: string) {
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(new CreatePreArrangementCommand(title)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`dac6-reporter/pre-arrangement/detail/${state.Payload.Id}`);
    });
  }

  addPreArrangementFromExistingCaseId(title: string, existingCaseId: string, archiveExisting: boolean, caseIdForCorrection: boolean, copyCount?: number, selectedFields?: string[],  copyAllFields: boolean = true) {
    this.fuseSplashScreenService.show();
    // title, selectedCase, archiveExisting, copyCount,


    this.commandService.executeCommand(new CreatePreArrangementFromExistingCaseCommand(title, existingCaseId, archiveExisting, caseIdForCorrection, copyCount, selectedFields, copyAllFields)).pipe().subscribe(state => {
      this.fuseSplashScreenService.hide();
      this.router.navigateByUrl(`dac6-reporter/pre-arrangement/detail/${state.Payload.Id}`);
    });
  }
  startDataSurvey() {
    const { flag } = this.selectedBasket;
    const bucket = flag === 'MX' ? '-MX' : '';
    const title = `Pre-Arrangement${bucket}`;
    const parameters = {'SourceTypes': [`PreArrangement${bucket}`, `Relevant-Taxpayers${bucket}`, `Intermediaries${bucket}`, `Other-Persons${bucket}`]};
    this.dialogService.createOrLoadDefaultSurveyTemplate(title, false, false, null, parameters);
  }

  importFromDataSurvey() {
    this.router.navigateByUrl('dac6-reporter/pre-arrangement/import');
  }

  import() {
    this.router.navigateByUrl('dac6-reporter/pre-arrangement/import');
  }

  deleteTransactions() {
    this.flag = true;
    this.deleteDisabled = true;
  }

  archive() {
    const selectionKey = 'prearrangement-archive-cases';
    const input = {
      ['SELECTION_KEY'] : selectionKey,
      ['ITEMS_SOURCE_TYPE']: this.sourceType
    };
    const filterId = selectionKey;
    const basketSourceType = BasketProvider.getBasketMappedSourceType(this.sourceType);
    const preCommand = new SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand(selectionKey, filterId, basketSourceType);
    this.commandService.executeCommand(preCommand).subscribe(prestate => {
      if (prestate) {
        const dialogModel = DialogModel.create('Select Case(s)', 'EntitySelectorDialogComponent', {
          filterId: selectionKey,
          filterTemplateId: 'prearrangement-archive-filter',
          apiKey: 'Dac6Api',
          input: input
        });
        dialogModel.okCaption = 'Next';
        dialogModel.minWidth = '1200px';
        dialogModel.maxWidth = '1200px';

        this.dialogService.showOkCancelDialog(dialogModel)
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe(actionState => {
            if (actionState && actionState.action === 'OK') {
              this.showArchiveDialog(filterId, selectionKey);
            }
          });
      }
    });
  }
  showArchiveDialog(filterId, selectionKey) {
    const dialogModel = DialogModel.create('Archive Case(s)',
      'ArchiveDialogComponent',
      {}, '500px', '490px', false);
    dialogModel.okCaption = 'Archive';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        console.log('Clicked Okay');
        console.log(data.data.input['comment']);
        const command = new ArchiveCaseCommand(filterId, selectionKey, this.sourceType, data.data.input['comment']);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSubject.invalidate();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  sendShowArchivedActivityCommand() {
    let showArchivedCommand = new PlatformCommand('ShowArchivedCommand','Dac6Api');
    var sourceKey = BasketProvider.getRootSourceKeyBySourceType(this.sourceType);
    showArchivedCommand.fieldValues['SourceType'] = sourceKey;
    showArchivedCommand.fieldValues['IsArchived'] = this.showArchived;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    this.commandService.executePlatformCommand(showArchivedCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }

  showArchivedChanged() {
    this.fuseSplashScreenService.show();
    console.log('showArchivedChanged');
    const config = Configuration.getSmartGridConfig(this.sourceType);
    config['Parameters']['SHOW_ARCHIVED'] = this.showArchived;
    this.sendShowArchivedActivityCommand();
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters, this.sourceType, config['Parameters']);
    this.invalidateSubject.invalidate();
    this.fuseSplashScreenService.hide();
  }

  startConversationActivity(event) {
    let startConversationCommand = new PlatformCommand('OpenConversationActivityCommand','Dac6Api');
    var sourceKey = BasketProvider.getRootSourceKeyBySourceType(event.item.type);
    startConversationCommand.fieldValues['SourceType'] = sourceKey;
    // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
    startConversationCommand.fieldValues['CaseId'] = event.item.id;
    this.commandService.executePlatformCommand(startConversationCommand).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
      },
      error => {
        console.error('Failed to basket manage section', error);
      });
  }

  onGridCellValueChange(event) {
    if (event.fieldDefinition && event.fieldDefinition.key === 'CaseId') {
      if (!event.item.isReadOnly) {
        this.openPreArrangementDetail(event.item.id);
      }
      return;
    }
    if (event.fieldDefinition && event.fieldDefinition.key === 'Suggested_Hallmarks') {
      this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '500px', '500px').subscribe();
      return;
    }
    if (event.action) {
      switch (event.action.id) {
        case 'Open':
          //if (!event.item.isReadOnly) {
            this.openPreArrangementDetail(event.item.id);
          //}
          break;
        case 'OpenHallmarkQuestion':
          this.navigateToDetailViewerTab(event.fieldDefinition, event.item);
          break;
        case 'Edit':
          this.edit(event);
          break;
        case 'itemClick':
          this.handleItemClick(event);
          break;
        case 'OpenCaseFolder':
          let viewDocumentCommand = new PlatformCommand('ViewDocumentActivityCommand','Dac6Api');
          var sourceKey = BasketProvider.getRootSourceKeyBySourceType(event.item.type);
          viewDocumentCommand.fieldValues['SourceType'] = sourceKey;
          // viewDocumentCommand.fieldValues[sourceKey+"Id"] = event.item.id;
          viewDocumentCommand.fieldValues['CaseId'] = event.item.id;
          this.commandService.executePlatformCommand(viewDocumentCommand).pipe(take(1)).subscribe(response => {
              console.log('commandState', response);
            },
            error => {
              console.error('Failed to basket manage section', error);
            });
          this.navigateToCaseFolder(event);
          break;
        case 'Start Conversation':
          this.startConversationActivity(event);
          this.getChatForThisCase(event);
          break;
        case 'ArchiveCase':
          this.archiveSingle(event.item.cells['CaseGUID'].value);
          break;
        case 'UnarchiveCase':
          this.unarchiveCase(event.item.cells['CaseGUID'].value);
          break;
        case 'Move to Arrangements':
          if (!event.item.isReadOnly) {
            this.router.navigateByUrl(`dac6-reporter/pre-arrangement/prearrangement-to-arrangement/${event.item.id}`);
          }
          break;
        case 'Delete':
          const command = new PreArrangeMentsDeleteCommand([event.item.id]);
          this.commandService.executeCommand(command).subscribe(state => {
            if (state) {
              this.invalidateSubject.invalidate();
              this.snackBarService.showInformation('Pre-Arrangement Deleted Successfully');
            }
          });
          break;
        case 'Copy':
          this.copyCase(event);
          break;
        case 'ViewActivity':
          this.trackCaseActiviy(event);
          break;
      }
    }
    console.log(event);
  }

  archiveSingle(caseGuid: string) {
    const dialogModel = DialogModel.create('Archive Case',
      'ArchiveDialogComponent',
      {}, '500px', '490px', false);
    dialogModel.okCaption = 'Archive';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        console.log(data.data.input['comment']);
        const command = new ArchiveSingleCaseCommand(caseGuid, data.data.input['comment']);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSubject.invalidate();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }

  unarchiveCase(caseGuid: string) {
      const message = 'You can unarchive this Case if you need to make additional edits, or if it was archived by mistake. Please ensure that any associated Tasks and Reports are updated and re-opened as required.';
      const question = 'Are you sure you want to unarchive this DAC6 Case?';
      this.dialogService.showConfirmDialog('Unarchive', 'Unarchive', 'Cancel', message, question ).subscribe(data => {
      if (data.action === 'OK') {
      const command = new UnarchiveCaseCommand(caseGuid);
      this.fuseSplashScreenService.show();
      this.commandService.executeCommand(command).subscribe(state => {
          this.invalidateSubject.invalidate();
          this.fuseSplashScreenService.hide();
      });
    }});
  }

  private openPreArrangementDetail(preArrangementId: string) {
    this.router.navigateByUrl(`dac6-reporter/pre-arrangement/detail/${preArrangementId}`);
  }

  getChatForThisCase(event) {
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: event.item.cells['CaseGUID'].value,
        caseId: event.item.cells['CaseId'].displayText
      }
    };
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${event.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      event.item.cells['CaseGUID'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }

  navigateToCaseFolder(event: any) {
    console.log('navigateToCaseFolder', event);
    if (event.action && event.action.tags.length) {
      let relativePath = event.action.tags[0];
      const caseId = event.item.cells['CaseId'].displayText;
      relativePath = relativePath.replace('[CASE_ID]', caseId);
      console.log('rellativePath', relativePath);
      // const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath')).pipe(take(2));
      // relativeUrl$.subscribe(state => {
      //   console.log('RelativeUrl', state);
      //   if (state) {
      //     console.log('Inside Routing ', state);
      //     this.router.navigateByUrl(state);
      //   }
      // });

      // QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});
      this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);
    }
  }

  edit(event: any) {
    console.log('Something Is Happening');
    if (event.fieldDefinition.cellEditor === 'EntityTextCellEditor') {
      // Sync
      const command = new SyncProjectEntityToCompanyCommand(false);
      this.commandService.executeCommand(command).pipe().subscribe(commandState => {
        console.log(commandState);
        if (commandState.Payload.ConfirmationNeeded) {
          this.dialogService.showYesNoDialog('Confirm Sync', `You were working with the entities of project '${commandState.Payload.Configuration.ProjectModel.Name}'. Do you want to sync with the current project?`)
            .subscribe(state => {
              if (state.action === 'OK') {
                const syncCommand = new SyncProjectEntityToCompanyCommand(true);
                this.commandService.executeCommand(syncCommand).pipe().subscribe(syncCommandState => {
                  console.log(syncCommandState);
                  this.openEditor(event);
                });
              } else {
                this.openEditor(event);
              }
            });
        } else {
          this.openEditor(event);
        }
      });
      return;
    }
    this.openEditor(event);
  }

  public openEditor(event) {
      const minWidth = '800px';
      const maxWidth = '800px';
    if(event.fieldDefinition.dataType === 'Attachment'){
      if(event.fieldDefinition.metaData['DirectoryPath']) {
        event.fieldDefinition.metaData['DirectoryPath'] = event.fieldDefinition.metaData['DirectoryPath'].replace('[CASE_ID]', event.item.cells['CaseId'].value);
      }
    }
      this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, this.sourceType, this.fieldHistorySourceType).subscribe(state => {
        console.log('After Edit', state);
        if (state.action === 'OK') {
          this.saveFieldDefinition(state.data.input.fieldDefinition, event.fieldSection);

          const item = {id: event.item.id, fieldValues: {}};
          const value = event.item.cells[event.fieldDefinition.key].value;
          item.fieldValues[event.fieldDefinition.key] = value;

          if(event.fieldDefinition.dataType === 'Attachment'){
            item.fieldValues[`${event.fieldDefinition.key}FileName`]= event.item.cells['fileName'];
          }

          const command = new UpdatePreArrangementCommand(item);
          const currentBasket = BasketProvider.getCurrentBasket();
          switch (currentBasket.id){
            case BasketId.Mexico:
              command.IsHallmarkAutomatedCopy = true;
              break;
            default:
          }
          this.commandService.executeCommand(command).pipe().subscribe(commandState => {
            if(commandState.Payload.FieldValues[`${event.fieldDefinition.key}NoteAvailable`]){
              this.snackBarService.showInformation(commandState.Payload.FieldValues[`${event.fieldDefinition.key}NoteAvailable`]);
            }
            this.invalidateSubject.invalidate();
          });
        }
      });
  }

  exportPreArrangement() {
    this.router.navigate(['export'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        includeArchives: this.showArchived
      }
    });
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  saveFieldDefinition(fieldDefinition: any, selectedFieldSection: any) {
    let fieldSettings = null;
    if (fieldDefinition && fieldDefinition.configKey) {
      const fieldConfig = Configuration.getSmartGridConfig(fieldDefinition.configKey);
      if (fieldConfig && fieldConfig.FieldSettings) {
        fieldSettings = fieldConfig.FieldSettings;
      }
    }
    if (fieldSettings) {
      const rootUrlKey = Configuration.getSmartGridConfig(this.sourceType).RootUrlKey;
      const url = `${Configuration.getConfig(rootUrlKey)}FieldSection/UpdateFieldDefinition`;
      const config = Configuration.getSmartGridConfig(this.sourceType);
      if (config) {
        const sourceType = config.SourceType;
        const updateFieldDefinitionCommand = new UpdateFieldDefinitionCommand([fieldDefinition], selectedFieldSection.id, ParticleConfig.ApplicationId, sourceType, true,
          url, !Configuration.getSmartGridConfig(this.sourceType).IsCompanySpecific);
        this.commandService.executeCommand(updateFieldDefinitionCommand).pipe().subscribe(commandState => {
          this.invalidateSubject.invalidate();
        });
      }
    }
  }

  changeViewType() {
    if (this.viewType === 'Compact') {
      this.viewType = 'Expanded';
    } else {
      this.viewType = 'Compact';
    }
  }

  private handleItemClick(event: any) {
    console.log('handle click');
    const participantsId = this.formatFieldDefinitionKey(event.fieldDefinition.key);
    const url = `dac6-reporter/participants/${participantsId}/${event.item.cells['CaseId'].displayText}`;
    this.router.navigate([url]);
  }
  private formatFieldDefinitionKey(key: string) {
   return  key === 'RelevantTaxpayers' ? 'relevant-taxpayers' : (key === 'Intermediaries' ? 'intermediaries' : 'other-persons');
  }
  public rowCallback = (context: RowClassArgs) => {
    return context.dataItem.isReadOnly ? 'row-locked' : '';
  }

  private copyCase(event: any) {
    const dialogModelTitle = 'Copy Case (' + event.item.cells.CaseId.displayText + ')';
    const dialogModel: DialogModel = DialogModel.create(
      dialogModelTitle,
      'CopyCaseDialogComponent', {'caseId': event.item.cells.CaseId.displayText, 'caseType': 'Pre-Arrangement', 'disableTypeChange': true, 'isReadOnly': event.item.isReadOnly, 'isArcived' : event.item.cells.Archived.value},
      '600px',
      '700px',
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res.action === 'OK') {
        switch (res.data.input.caseType) {
          case 'Pre-Arrangement':
            if (res.data.input.specifyField) {
              res.data.input['title'] = event.item.cells.Title.value;
              this.openSelectFieldDialog(res.data.input.selectedCase, 'prearrangementmodel', 'PreArrangement', res, event.item.id, res.data.input.copyCount);
            } else {
              this.addPreArrangementFromExistingCaseId(event.item.cells.Title.value, event.item.id, res.data.input.archiveExisting, res.data.input.caseIdUsedforCorrection, res.data.input.copyCount );
            }
            break;
        }
      }

    });
  }

  private openSelectFieldDialog(selectedCase: string, dbmodelType: string, sourceType: string, caseData: any, existingId: string, copyCount: number = 1) {
    const dialogModel: DialogModel = DialogModel.create(
      'Select Data',
      'VirtualGridDialogComponent', {sourceKey: 'Dac6-RowFieldData-Config', params: {'rowId': selectedCase, 'dbmodelType': dbmodelType, 'sourceType': sourceType}},
    );
    dialogModel.isFullscreen = true;
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res.action === 'OK') {
        switch (sourceType) {
          case 'PreArrangement':
            this.addPreArrangementFromExistingCaseId(caseData.data.input.title, existingId, caseData.data.input.archiveExisting, false, copyCount, res.data.input.selectedFields, false);
            break;
        }
      }
    });
  }

  onBasketChange(event) {
    this.filterId = null;
    this.toggleAnnouncement(event);
    setTimeout(() => {
      this.filterId = Configuration.getBasketMappedSourceType('PreArrangement');
    }, 200);
  }

  dismissKey = 'prearrangement-announcement-dismissed';

  private toggleAnnouncement(event) {
    if (event && event.id == 'dac6-eu' && !this.isAnnouncementDismissed()) {
      this.showAnnouncement = true;
    } else {
      this.showAnnouncement = false;
    }
  }

  onAnnouncementDismissed() {
    window.sessionStorage.setItem(this.dismissKey, 'dismissed')
  }

  private isAnnouncementDismissed() {
    if(window.sessionStorage.getItem(this.dismissKey))
      return true;
    return false;
  }

  private trackCaseActiviy(event: any) {
    this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode', id: event.item.cells['ReferenceCode'].value, title: event.item.cells['CaseId'].value, isDefault: false, isUserAction: true}));
  }
}
